import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import { transformPieChartData, generateStationDetail } from '../ProductionDashboardHelpers';

export default function PerformanceTab({ title, data, detailPrefix, noDataMessage }) {
  return (
    <div>
      <h3>{title}</h3>
      {data && data.length > 0 ? (
        <div className="charts-grid">
          <MarketShare
            data={transformPieChartData(data, 'shift')}
            radius={['95%', '83%']}
            title={`${title} By Shifts`}
          />
          {generateStationDetail(data, detailPrefix)}
        </div>
      ) : (
        <div className="p-4 text-center border rounded">{noDataMessage}</div>
      )}
    </div>
  );
}

PerformanceTab.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  detailPrefix: PropTypes.string.isRequired,
  noDataMessage: PropTypes.string.isRequired
};
